<template>
<div v-bind:class="{ 'mb-3' : !compactLayout }">
    <div class="col-sm-auto">
        <button type="button" v-if="hasAudioFile && !isPlaying" v-on:click="playAudioFile" class="btn btn-success mb-2">
            <span v-bind:class="{ 'small': compactLayout, 'border-2' : !compactLayout  }">
                Play audio <span v-if="!compactLayout">file</span>
            </span>
        </button>
        <button type="button" v-if="hasAudioFile && isPlaying" v-on:click="pauseAudioFile" class="btn btn-danger mb-2">
            <span v-bind:class="{ 'small': compactLayout, 'border-2' : !compactLayout  }">
                Pause audio <span v-if="!compactLayout">file</span>
            </span>
        </button>
        <button type="button" v-on:click="uploadAudioFile" class="btn btn-primary mb-2" v-bind:class="{ 'border-danger': alertUploadButton, 'border-2' : !compactLayout }">
            <span v-if="hasAudioFile" v-bind:class="{ 'small': compactLayout }">
                Replace audio <span v-if="!compactLayout">file</span>
            </span>
            <span v-if="!hasAudioFile" v-bind:class="{ 'small': compactLayout }">
                Upload audio <span v-if="!compactLayout">file</span>
            </span>
        </button>
        <button type="button" v-if="hasAudioFile" v-on:click="deleteAudioFile" class="btn btn-secondary mb-2">
            <span v-bind:class="{ 'small': compactLayout, 'border-2' : !compactLayout  }">
                Delete audio <span v-if="!compactLayout">file</span>
            </span>
        </button>
    </div>
    <div v-if="!compactLayout" class="col">
        <div v-if="!hasAudioFile">
            <div>No audio track uploaded</div>
            <div>Valid exensions: {{extensions.join(', ')}}</div>
        </div>
        <div v-if="hasAudioFile">
            <div>Audio track has been uploaded.</div>
            <div>Duration: {{trackTime}}</div>
        </div>
    </div>
</div>
</template>
<script>
import _ from "lodash";

export default {
    props: {
        episode: Object,
        snickId: Number,
        episodeId: Number,
        extensions: Array,
        alertUploadButton: Boolean,
        hasAudioFile: Boolean,
        removeUploadButtonAlert: Function,
        setSuccessMessage: Function,
        setErrorMessage: Function,
        compactLayout: Boolean,
    },
    data() {
        return {
            isPlaying: false,
            audioFile: '',
            baseUrl: window.baseUrl
        }
    },
    methods: {
        playAudioFile(e) {
            const url = `/docus/${this.snickId}/episodes/${this.episodeId}/audio`
            if (this.audioFile && this.audioFile.paused) {
                this.isPlaying = true;
                this.audioFile.play();
                this.handleAudioEnd();
                return true
            }

            axios.get(url).then(response => {
                let audioPath  = this.getAudioPath(response.data)
                this.audioFile = new Audio(audioPath);
                this.isPlaying = true;
                this.audioFile.play();
                this.handleAudioEnd();
            })
        },
        pauseAudioFile(e) {
            this.audioFile.pause();
            this.isPlaying = false;
        },
        handleAudioEnd() {
            this.audioFile.addEventListener('ended', (event) => {
                this.isPlaying = false
            });
        },
        uploadAudioFile(e) {
            this.removeUploadButtonAlert();
            const input = document.createElement('input');
            input.type="file";
            input.onchange = (event) => {
                const file = event.target.files[0];
                this.setAudioTrack(file);
            };
            input.click();
        },
        deleteAudioFile(e) {
            const url = `/docus/${this.snickId}/episodes/${this.episodeId}/audio`;
            axios.delete(url).then(() => {
                this.episode.audio_track = null;
                this.episode.duration = null;
                this.setErrorMessage(false);
                if (this.compactLayout) {
                    this.setSuccessMessage('Success!');
                } else {
                    this.setSuccessMessage('The audio file was deleted.');
                }
            }).catch((error) => {
                this.setSuccessMessage(false);
                if (this.compactLayout) {
                    this.setErrorMessage('Error.');
                } else {
                    this.setErrorMessage('Something went wrong. The file was not deleted.');
                }
            });
        },
        getAudioPath(path) {
            if (path.includes('/storage/')) {
                return path
            }

            return `/storage/${path}`
        },
        setAudioTrack(track) {
            const reader = new FileReader();
            const url = `/docus/${this.snickId}/episodes/${this.episodeId}/audio`;

            reader.onload = (e) => {
                const data = e.target.result;
                const filename = track.name;
                axios.post(url, { filename, data })
                    .then((response) => {
                        if (response.data.audio_track && response.data.duration) {
                            this.episode.audio_track = response.data.audio_track;
                            this.episode.duration = response.data.duration;
                            this.setErrorMessage(false);
                            if (this.compactLayout) {
                                this.setSuccessMessage('Success!');
                            } else {
                                this.setSuccessMessage('Success! The audio file was uploaded.');
                            }
                            this.audioFile = ''
                            this.isPlaying = false
                        } else {
                            this.setSuccessMessage(false);
                            if (this.compactLayout) {
                                this.setErrorMessage('Error.');
                            } else if (this.hasAudioFile) {
                                this.setErrorMessage('Something went wrong. The audio file was not replaced.');
                            } else {
                                this.setErrorMessage('Something went wrong. The audio file was not uploaded.');
                            }
                        }
                    })
                    .catch((error) => {
                        this.setSuccessMessage(false);
                        if (this.compactLayout) {
                            this.setErrorMessage('Error.');
                        } else {
                            this.setErrorMessage('Something went wrong. The file was not uploaded.');
                        }
                        console.log(error);
                    });
            };

            reader.readAsDataURL(track);
        },
    },
    computed: {
        trackTime: function() {
            const hours = _.floor(this.episode.duration / 3600);
            const minutes = _.padStart(_.floor(this.episode.duration % 3600 / 60), 2, '0');
            const seconds = _.padStart(_.floor(this.episode.duration % 60), 2, '0');

            if (hours) return `${hours}:${minutes}:${seconds}`;
            return `${minutes} : ${seconds}`
        },
    }
}
</script>
<style>
.border-2 {
    border-width: 2px !important;
}
</style>
